import { Routes } from '@angular/router';
import { IntegrationsComponent } from './containers/integrations/integrations.component';
import { MainComponent } from './containers/main/main.component';

export const INTEGRATIONS_ROUTES: Routes = [
  {
    path: '',
    component: MainComponent,
  },
  {
    path: ':id',
    component: IntegrationsComponent,
  },
];
